export const data = [
  {
    id: "1",
    title: "Software Engineer 2",
    company: "Procom",
    dates: "Jul 2023 - present",
    duties: [
      "Developed key features for recruitment platform using React, .Net and RxJS.",
      "Led the entire refactoring of legacy auth portal with modern security practices and reusable components",
      "Implemented the contract extensions feature for Procom’s onboarding team which saved $100K/year renewals",
      "Improved the resource library by caching image thumbnails, adding intersection observers and by designing custom virtualized list which ultimately reduced the server load and enhanced the user experience.",
    ],
  },
  {
    id: "2",
    title: "Software Engineer",
    company: "Oanda",
    dates: "November 2021 - May 2023",
    duties: [
      "Implemented robust trading features for mobile and web, ensuring 99.9% uptime for real time market operations.",
      "Build the advanced charting solution, empowering traders with data driven insights and pattern recognition.",
      "Drove full feature development lifecycle from planning, development, code reviews, unit testing to deployments.",
    ],
  },
  {
    id: "3",
    title: "Software Engineer",
    company: "Northline",
    dates: "June 2020 - November 2021",
    duties: [
      "Lead the design and development of many applications that communicates with embedded devices and display the real time traffic data, which is also currently being used by the City of Scugog, Pickering etc.",
      "reated inventory management system with interactive dashboard and automated reporting, reducing inventory processing time by 25%.",
      "Worked with video frame mapping application in python",
      "Developed a Rest API project performing basic crud operations in Nodejs and deployed it on Heroku",
    ],
  },
  {
    id: "4",
    title: "Student Researcher",
    company: "Wimtach",
    dates: "May 2019 - May 2020",
    duties: [
      "Designed and developed solutions for embedded systems, e-commerce applications and many others using technologies like React Native, Flutter, React, Android.",
      "Led the team of three in the application development process of condominium management system as per designs provided by the clients. Application was built in React Native usinf styled components for designing.",
      "Continuous team mentoring, code reviews, technical documentation, release management.",
      "Worked with Viro React, an Augmented Reality library for React Native.",
    ],
  },
];
